import React from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import { RowAction } from '../../../../../components/row-action';
import { formatDate } from '../../../../../utils/date';
import { AmendmentDetailController } from '../context/amendment-detail-controller';
import { useAmendmentDetailState } from '../context/amendment-detail-context';
import { EmptyRow, dashIfEmpty } from './detail-parts';

export function AttachmentsTab({ ctrl }: { ctrl: AmendmentDetailController }) {
    const { attachments } = useAmendmentDetailState();

    function handleFileSelected(e: React.ChangeEvent<HTMLInputElement>) {
        const file = e.target.files?.[0];
        if (!file) return;
        ctrl.uploadAttachment(file);
        e.target.value = '';
    }

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <Button variant="contained" component="label" startIcon={<AttachFileIcon />}>
                    Enviar Arquivo
                    <input type="file" hidden onChange={handleFileSelected} />
                </Button>
            </Box>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Nome</TableCell>
                            <TableCell>Tipo</TableCell>
                            <TableCell>Data</TableCell>
                            <TableCell align="right">Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {attachments.length === 0 && <EmptyRow colSpan={4} message="Nenhum anexo enviado" />}
                        {attachments.map((attachment) => (
                            <TableRow key={attachment.id} hover>
                                <TableCell>{attachment.title || attachment.originalFileName}</TableCell>
                                <TableCell>{dashIfEmpty(attachment.fileType)}</TableCell>
                                <TableCell>{dashIfEmpty(formatDate(attachment.createdAt))}</TableCell>
                                <TableCell align="right">
                                    <Box sx={{ display: 'inline-flex' }}>
                                        <RowAction title="Baixar" onClick={() => ctrl.downloadAttachment(attachment.id, attachment.originalFileName || 'arquivo')}><DownloadIcon fontSize="small" /></RowAction>
                                        <RowAction title="Excluir" color="error" onClick={() => ctrl.deleteAttachment(attachment.id)}><DeleteIcon fontSize="small" /></RowAction>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
}
